import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';
import Swal from 'sweetalert2';

declare var bootstrap: any;
@Component({

  selector: 'app-support',

  templateUrl: './support.component.html',

  styleUrls: ['./support.component.css']

})

export class SupportComponent implements OnInit {

  Info: any;

  posts: any;

  helpTxt: any;

  pastData: any;

  answers: any;

  groups: any;

  showPosts: boolean = true;

  reqModel: FormGroup = this.formBuilder.group({

    tiTiketSubject: new FormControl(-1),

    strDetail: new FormControl(''),

    strCitizenAnswer: new FormControl(''),

    strImage: new FormControl(''),

  });

  constructor(
    private otherService: OtherService,

    private toastr: ToastrService,

    private dialog: MatDialog,

    private formBuilder: FormBuilder,

    private accountService: AccountService,

    private router: Router,

    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {

    this.otherService.setTitle('شکایت از جرثقیل | امداد ران و جرثقیل سیار')

    this.Info = this.otherService.getLocalStorage();

    this.getBaseData();

  }

  ngOnDestroy() {

    this.otherService.setTitle('')

  }

  getBaseData() {
    var model = {
      iTaxiLon_User: this.Info.Id,
      strSession: this.Info.session,
    };

    this.accountService.TaxiLon_Tiket_List(model).subscribe((response) => {
      let res = JSON.parse(response.toString());
      this.posts = res;

    });
    this.accountService.TaxiLon_Tiket_Subjects_List(model).subscribe((response) => {
      let res = JSON.parse(response.toString());
      this.groups = res;
    });
  }

  closeModal() {
    let myModal = document.getElementById('gallery');

    var modal = bootstrap.Modal.getInstance(myModal);

    modal.hide();
  }

  changeMode() {
    this.showPosts = !this.showPosts;
  }

  submitPost() {
    let model = this.reqModel.value;
    model.iTaxiLon_User = this.Info.Id;
    model.strSession = this.Info.session;

    if (model.tiTiketSubject == '' || model.strDetail == '') {
      Swal.fire({
        title: 'لطفا موارد ستاره دار را وارد نمایید',
        icon: 'error',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: 'تایید',
      });
    } else {
      Swal.fire({
        title: 'آیا از ثبت این مورد اطمینان دارید؟',
        icon: 'warning',
        showCancelButton: true,
        showConfirmButton: true,
        reverseButtons: true,
        confirmButtonColor: '#10b981',
        confirmButtonText: 'تایید',
        cancelButtonText: 'لغو',
      }).then((result) => {
        if (result.isConfirmed) {
          this.accountService.TaxiLon_Tiket_Save(model).subscribe((response) => {
            let res = JSON.parse(response.toString());

            if (res.bError == true) {
              Swal.fire({
                title: res.strError,
                icon: 'error',
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: 'تایید',
              });
            } else {
              Swal.fire({
                title: 'با موفقیت ثبت شد',
                icon: 'success',
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: 'تایید',
              });
              this.getBaseData();
              this.changeMode();
              this.reqModel.controls['tiTiketSubject'].setValue(-1);
              this.reqModel.controls['strDetail'].setValue('');
              this.reqModel.controls['strCitizenAnswer'].setValue('');
            }
          });
        }
      });
    }
  }

  deletePost(item) {
    Swal.fire({
      title: 'آیا از حذف این گزینه اطمینان دارید؟',
      icon: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      reverseButtons: true,
      confirmButtonColor: '#10b981',
      confirmButtonText: 'تایید',
      cancelButtonText: 'لغو',
    }).then((result) => {
      if (result.isConfirmed) {
        var model = {
          iTaxiLon_User: this.Info.Id,

          strSession: this.Info.session,

          iTaxiLon_Tiket: item,
        };
        this.accountService.TaxiLon_Tiket_Delete(model).subscribe((response: any) => {
          let res = JSON.parse(response);

          if (res.bError == true) {
            Swal.fire({
              title: 'خطا',
              icon: 'error',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'تایید',
            });
          } else {
            Swal.fire({
              title: 'با موفقیت حذف شد',
              icon: 'success',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'تایید',
            });
            this.getBaseData();
            this.closeModal();
          }
        });
      }
    });
  }

  onFileInput(file: any) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this.accountService.toastSwal('error', ' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        this.reqModel.controls['strImage'].setValue(base64String.replace('data:image/jpeg;base64,', ''));

      };

    }

  }


}
